import {Component, Input, OnInit} from '@angular/core';
import {UserAvatarModel} from "./user-avatar.model";
import {style} from "@angular/animations";

@Component({
  selector: 'sb-user-avatar',
  templateUrl: './user-avatar.component.html',
  styleUrls: ['./user-avatar.component.scss']
})
export class UserAvatarComponent implements OnInit {
  @Input()
  user: UserAvatarModel;

  @Input()
  isCurrentUser: boolean = false

  @Input()
  displayToolTip: Boolean = false

  /**
   * size style suffix ie: xsmall, small, large, xlarge
   */
  @Input()
  size?: string | null

  constructor() { }


  ngOnInit(): void {
  }

  getInitials(): string {
    const firstName = this.user.firstName;
    const lastName = this.user.lastName;
    const firstInitial = (firstName && firstName.length > 0) ? firstName.charAt(0) : "";
    const lastInitial = (lastName && lastName.length > 0) ? lastName.charAt(0) : "";
    return firstInitial.toUpperCase() + lastInitial.toUpperCase();
  }

  protected readonly style = style;

  getToolTipContent(): string {
    const firstName = this.user.firstName;
    const lastName = this.user.lastName;
    const firstNameCap = (firstName && firstName.length > 0) ? firstName.charAt(0).toUpperCase() + firstName.slice(1) : null;
    const lastNameCap = (lastName && lastName.length > 0) ? lastName.charAt(0).toUpperCase() + lastName.slice(1) : null;
    if (firstNameCap || lastNameCap) {
      return (firstNameCap || "") + (firstNameCap && lastNameCap ? " " : "") + (lastNameCap || "")
    } else {
      return this.user.userId
    }
  };

  getSizeClass(): string {
    return this.size ? `e-avatar-${this.size}` : ''
  }

  getUserTypeClass(): string {
    return this.isCurrentUser ? `user-current` : 'user-other'
  }

  // Custom will not display the tooltip unless a custom event is bound, used to disable tooltip here
  getOpensOn(): 'Hover' | 'Custom' {
    return this.displayToolTip ? 'Hover' : 'Custom'
  }
}
